module.exports = __webpack_public_path__ + "img/57_23.638340c5.png";